import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { ExceptionTable } from "./ExceptionTable";
import { WeeklySchedule } from "./WeeklySchedule";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Tooltip } from '@material-ui/core';
import { useState, useEffect } from "react";

export const WeeklyScheduleDialog = (props) => {

    const [errors, setErrors] = useState({});
    
    const handleCloseClick = () => {
        props.onClose();
    };
    
    useEffect(() => {

        hideRefreshButton();
        // eslint-disable-next-line
    }, []);

    const tableProps = {
        resource: "exceptions", // Cambias el resource aquí
        mode: "show", // o el modo que necesites
        basePath: "/exceptions", 
        id: props?.identity?.professionalId,
        isProfessional: true// importante para react-admin
    };

    
    const hideRefreshButton = () => {
        const button = document.querySelector('header button[aria-label="Refrescar"]');
        if (!button) return;

        button.style.display = 'none'; // Ocultar el botón
    };

    return (
        <Dialog
            fullWidth
            open={props.open}
            onClose={handleCloseClick}
        >
            {
                <MuiDialogTitle>
                    {'Horario de ' + props?.identity?.name}
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseClick}
                        style={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </MuiDialogTitle>
            }
            <DialogContent
                style={{ height: '35rem', display: 'flex', flexDirection: 'column' }}>
                
                <div className="div-horario">
                            <Tooltip title="Horario" placement="right">
                                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Horario</span>
                            </Tooltip>
                            <span>Establezca un horario para el profesional:</span>
                            <div style={{ width: '100%', padding: '0%' }}>
                                <WeeklySchedule 
                                {...tableProps} 
                                isProfessional={true} 
                                scheduleEdit={false} 
                                errors={errors}
                                setErrors={setErrors}
                                isSave={false}/>
                            </div>

                        </div>

                        <div className="div-horario" style={{ marginTop: '1rem'}}>
                            <Tooltip title="Horario" placement="right">
                                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Excepciones</span>
                            </Tooltip>
                            <span>Añade una excepción:</span>
                            <div style={{ width: '100%'}}>
                                {ExceptionTable(tableProps, tableProps.mode)}
                            </div>
                            
                        </div>

            </DialogContent>
        </Dialog>
    )
}